// Hrvatski tekstovi su prijevod prototipa, doslovno gdje se zaslon podudara.
export default {
    offer: {
        save_hint: 'Otvara se dijaloški okvir za ispis — za PDF odaberite odredište »Spremi kao PDF«.',
        invalid_title: 'Ponuda nije dostupna',
        invalid_text: 'Poveznica do ponude je istekla ili je zamijenjena. Obratite se hotelu.',
        eyebrow: 'Ponuda za grupu',
        eyebrow_reservation: 'Ponuda za vas',
        nights: 'noćenja',
        financials: 'Ponuda',
        col_item: 'Stavka',
        col_quantity: 'Količina',
        col_price: 'Cijena/jed.',
        col_discount: 'Popust',
        col_vat: 'PDV',
        col_amount: 'Iznos',
        total_net: 'Ukupno bez PDV-a',
        vat_at: 'PDV {rate} %',
        remaining: 'Za platiti',
        rooms: 'Smještaj',
        per_night: 'noć',
        up_to: 'do {count} osoba u sobi',
        total: 'Ukupno',
        paid: 'Već plaćeno',
        services: 'Usluge hotela',
        included: 'dostupno gostima',
        valid_until: 'Ponuda vrijedi do {date}.',
        contact: 'Pitanja i potvrda',
        print: 'Ispiši',
        save: 'Spremi PDF',
        confirm: 'Potvrdi ponudu',
        confirmed_at: 'Ponuda potvrđena {date}. Hvala — hotel je obaviješten.',
        units: { hour: 'sat', day: 'dan', night: 'noć', person: 'osobu', use: 'uporabu', item: 'kom', treatment: 'tretman' },
    },
    rooming: {
        pick: 'Odaberi …',
        invalid_title: 'Poveznica nije valjana',
        invalid_text: 'Poveznica za unos gostiju je istekla ili je zamijenjena. Obratite se hotelu.',
        intro: 'Upišite goste svoje grupe. Hotel će popis pregledati i rasporediti po sobama — upis ovdje još ne znači rezervaciju.',
        add_title: 'Dodaj gosta',
        first_name: 'Ime',
        last_name: 'Prezime',
        email: 'E-adresa',
        phone: 'Telefon',
        notes: 'Napomene',
        add: 'Dodaj',
        added: 'Gost je dodan na popis.',
        failed: 'Unos nije bilo moguće spremiti.',
        entered: 'Upisani gosti ({count})',
        none_yet: 'Još nema upisanih gostiju.',
        booking_title: 'Unos suputnika',
        rooms_title: 'Sobe',
        rooms_count: '{count} soba',
        filled_of: 'Upisano {filled} od {capacity}',
        pick_room_first: 'Najprije odaberite sobu gore.',
        adding_to: 'Dodajete u: {room}',
        unassigned: 'Neraspoređen',
        date_of_birth: 'Datum rođenja',
        nationality: 'Državljanstvo',
        nationality_hint: 'npr. SI',
        document_type: 'Vrsta dokumenta',
        document_type_hint: 'npr. putovnica',
        document_number: 'Broj dokumenta',
        confirmed: 'Potvrđeno',
        booked_note: 'Već raspoređeni gosti potvrđeni su od strane hotela; promjene javite recepciji.',
        register_hint: 'Datum rođenja, državljanstvo i dokument potrebni su za prijavu gosta prema zakonu. Podatke na recepciji provjeravamo pri dolasku.',
    },
    keys: {
        title: 'Ključevi',
        your_room: 'VAŠA SOBA',
        your_pin: 'VAŠ PIN',
        pin_text: 'PIN kodom otvarate sva svoja vrata, a možete koristiti i daljinsko otvaranje u nastavku.',
        your_keys: 'VAŠI KLJUČEVI',
        door_room: 'Soba',
        room_on_arrival: 'dodijeljena pri dolasku',
        hold: 'Držite za otključavanje',
        unlocked: 'Otključano',
        preview_note: 'Daljinsko otvaranje radit će kada hotel poveže brave sa sustavom — do tada je pretpregled.',
        demo_done: 'Pretpregled — brave još nisu povezane.',
    },
    nav: {
        menu: 'Izbornik',
        roomservice_hint: 'Jela i pića ravno u sobu',
        roomservice: 'Posluga u sobi',
        keys: 'Ključevi',
        short_keys: 'Ključevi',
        overview: 'Pregled',
        checkin: 'Prijava',
        stay: 'Moj boravak',
        arrival: 'Dolazak',
        services: 'Usluge',
        payments: 'Plaćanja i računi',
        short_overview: 'Pregled',
        short_checkin: 'Prijava',
        short_arrival: 'Dolazak',
        short_services: 'Usluge',
        short_payments: 'Račun',
        house: 'Hotel',
    },
    general: {
        back: 'Natrag',
        cancel: 'Odustani',
        close: 'Zatvori',
        save_failed: 'Spremanje nije uspjelo. Pokušajte ponovno.',
    },
    theme: {
        title: 'Svijetla/tamna tema',
        to_dark: 'Uključi tamnu temu',
        to_light: 'Uključi svijetlu temu',
    },
    overview: {
        eyebrow: 'VAŠ SLJEDEĆI BORAVAK',
        language: 'Jezik',
        welcome: 'Dobrodošli u',
        welcome_named: 'Poštovani, {names}',
        and: 'i',
        subtitle: 'Ovdje uredite sve prije dolaska i tijekom boravka.',
        arrival: 'DOLAZAK',
        departure: 'ODLAZAK',
        reservation: 'REZERVACIJA',
        ready: 'Spremni za dolazak',
        almost: 'Spremni za dolazak',
        all_done: 'Sve je uređeno',
        one_more_step: 'Još jedan korak',
        steps_left_two: 'Još 2 koraka',
        steps_left_few: 'Još {n} koraka',
        step_profile: 'Osobni podaci',
        step_document: 'Dokument',
        step_payment: 'Plaćanje',
        finish_checkin: 'Dovrši prijavu',
        card_checkin: 'Online prijava',
        card_checkin_text: 'Dopunite podatke gostiju i skratite postupak na recepciji.',
        card_checkin_go: 'Nastavi prijavu',
        card_stay: 'Moj boravak',
        card_stay_text: 'Soba, vrijeme dolaska, posebne želje i upute za dolazak.',
        card_stay_go: 'Pogledaj rezervaciju',
        card_services: 'Usluge hotela',
        card_services_text: 'Masaža, sauna, večera ili najam bicikala.',
        card_services_go: 'Istraži usluge',
        card_room_service: 'Posluga u sobi',
        card_room_service_text: 'Jela i pića iz hotelske kuhinje, ravno u sobu.',
        card_room_service_go: 'Na jelovnik',
        card_money: 'Troškovi i plaćanja',
        card_money_go: 'Otvori račun boravka i plaćanje',
        card_keys_title: 'Ključevi',
        card_keys_none: 'Ključ i PIN čekaju vas nakon prijave i dodjele sobe.',
        card_keys_get: 'Preuzmi ključ',
        card_keys_go: 'Svi ključevi i PIN',
        card_arrival: 'Dolazak i lokacija',
        card_arrival_text: 'Adresa, navigacija te fotografije ulaza, parkirališta i garaže.',
        card_arrival_go: 'Pogledaj upute za dolazak',
        card_house: 'Hotel i okolica',
        card_house_text: 'Wi-Fi, radno vrijeme, pismo dobrodošlice, cjenik i što se događa u gradu.',
        card_house_go: 'Otvori informacije hotela',
        partly_paid: 'Djelomično plaćeno',
        charges: 'Troškovi boravka',
        parking_charges: 'Troškovi parkiranja',
        paid: 'Plaćeno',
        balance: 'Preostatak',
    },
    checkin: {
        pick: 'Odaberi …',
        title: 'Online prijava',
        subtitle: 'Podaci se sigurno prenose izravno u hotel.',
        step_guests: 'Gosti',
        step_documents: 'Dokumenti',
        step_payment: 'Plaćanje',
        step_confirm: 'Potvrda',
        guests_title: 'Gosti na rezervaciji',
        unnamed: 'Gost bez imena',
        document_read: 'Dokument pročitan · podaci potpuni',
        document_missing: 'Nedostaje dokument',
        document_entered: 'Podaci uneseni · recepcija ih provjerava pri dolasku',
        done_badge: 'Završeno',
        add_document: 'Unesi podatke',
        add_companion: 'Dodaj pratitelja',
        first_name: 'Ime',
        last_name: 'Prezime',
        companion_hint: 'Dodajte osobu koja boravi s vama. Dokument unosite u sljedećem koraku, kao i za sebe.',
        companion_room: 'Soba',
        companion_save: 'Dodaj osobu',
        companion_saved: 'Osoba je dodana — unesite još njezin dokument.',
        companion_incomplete: 'Upišite ime i prezime (i odaberite sobu).',
        companion_failed: 'Osobu nije bilo moguće dodati — soba je možda već puna. Obratite se recepciji.',
        wishes_title: 'Dolazak i želje',
        expected_arrival: 'Predviđeni dolazak',
        phone: 'Broj mobitela',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Posebne želje',
        wishes_placeholder: 'Mirna soba, viši kat',
        plate: 'Registarska oznaka',
        plate_hint: 'Ako ćete auto parkirati na parkiralištu ili u garaži.',

        // Marketing consent (docs/MARKETING.md §13). Never pre-ticked.
        consent_title:  'Ponude e-poštom',
        consent_label:  'Želim primati ponude i novosti hotela e-poštom.',
        consent_hint:   'Suglasnost možete povući u svakom trenutku — i jednim klikom na dnu svake poruke. Poruke o vašoj rezervaciji stižu neovisno o tome.',
        consent_failed: 'Suglasnost nije bilo moguće spremiti.',
        save_for_later: 'Spremi za poslije',
        continue_payment: 'Nastavi na plaćanje',
        saved: 'Prijava je spremljena.',
        doc_title: 'Dodaj dokument',
        doc_type: 'Vrsta dokumenta',
        doc_number: 'Broj dokumenta',
        doc_nationality: 'Državljanstvo',
        doc_nationality_hint: 'Dvoslovna oznaka države, npr. SI, DE, IT.',
        doc_birth: 'Datum rođenja',
        doc_save: 'Spremi podatke',
        doc_saved: 'Dokument je spremljen.',
        doc_incomplete: 'Ispunite sva polja — bez njih prijavu gosta nije moguće poslati.',
        doc_hint: 'Dokument očitajte aplikacijom Imprion ID Scan ili podatke unesite ručno. Fotografija se ne sprema.',
        doc_manual: 'Ručni unos',
        doc_idscan: 'Otvori ID Scan',
        doc_coming: 'Očitavanje dokumenta putem portala uskoro stiže — do tada dokument očitavaju na recepciji.',
    },
    stay: {
        requests_title: 'VAŠE ZAMOLBE',
        request_extension: 'Produljenje za {nights} noći',
        request_late_checkout: 'Kasna odjava',
        request_pending: 'čeka recepciju',
        request_confirmed: 'potvrđeno',
        request_declined: 'nažalost nije moguće',
        title: 'Moj boravak',
        room: 'Soba',
        room_assigned_on_arrival: 'Soba će biti dodijeljena pri dolasku',
        occupancy: '{adults} odraslih · {children} djece',
        expected: 'očekivano {hour}',
        late_checkout: 'Zatraži kasniji odlazak',
        room_released_title: 'Odlazak iz sobe',
        room_released_text: 'Odjavljeni ste, ali soba je kod nas još uvijek zauzeta. Kada javite da ste je napustili, možemo je pripremiti za sljedećeg gosta.',
        room_released: 'Napustio sam sobu',
        room_released_sent: 'Hvala - javili smo da je soba slobodna.',
        extension_check: 'Provjeri moguće produljenje',
        extension_title: 'Produljenje boravka',
        extension_hint: 'Provjerite jesu li noći nakon vašeg odlaska još slobodne. Želja ide recepciji, koja produljenje potvrđuje — ništa se ne rezervira samo.',
        extension_same_room: 'Slobodno — možete ostati u istoj sobi',
        extension_other_room: 'Slobodno — uz promjenu sobe',
        extension_full: 'Nažalost nema slobodnih soba za te noći.',
        extension_price: 'procjena {amount}/noć prema vašem paketu',
        extension_request: 'Zatraži +{nights}',
        extension_sent: 'Želja za produljenje poslana je recepciji — javit će vam se.',
        late_checkout_sent: 'Zahtjev za kasniji odlazak je poslan.',
        call: 'Nazovi',
        status_booked: 'Rezervirano',
        status_confirmed: 'Potvrđeno',
        status_checked_in: 'Prijavljeni',
        status_checked_out: 'Odjavljeni',
    },
    parking: {
        maps_card: 'Lokacija i navigacija u Google Maps',
        card_title: 'Parkiranje',
        card_title_both: 'Parkiranje i garaža',
        card_text: 'Unesite registarsku oznaku za automatsko otvaranje rampe pri dolasku i tijekom boravka.',
        add: 'Dodaj registarsku oznaku',
        change: 'Promijeni ili dodaj pristup',
        active_badge: 'Rampa aktivna',
        active_until: 'Automatski ulaz aktivan je do {date}.',
        title: 'Automatski ulaz u garažu',
        hint: 'Kamera kod rampe će tijekom boravka prepoznati registarsku oznaku i automatski otvoriti rampu.',
        maps: 'Otvori u Google Maps',
        copy: 'Kopiraj adresu',
        copied: 'Adresa je kopirana.',
        plate: 'Registarska oznaka vozila',
        placeholder: 'npr. MB AB-123',
        validity: 'Valjanost pristupa',
        validity_range: '{from} do {to}',
        activate: 'Potvrdi i aktiviraj',
        activated: 'Registarska oznaka {plate} aktivirana je za automatski ulaz.',
        check_plate: 'Provjerite registarsku oznaku.',
        extra_cars: 'Dodatna vozila',
        add_car: 'Dodaj dodatni auto',
        remove_car: 'Ukloni',
        removed: 'Registarska oznaka je uklonjena; rampa je više neće propustiti.',
        removed_booking_kept: 'Registarska oznaka je uklonjena. Rezervaciju parkirališta putem portala više nije moguće otkazati — riješit će je recepcija.',
        first_car_price: 'Parkirno mjesto za boravak: {amount}. Iznos se dodaje na račun boravka.',
        included_note: 'Parkiranje je uključeno u cijenu noćenja.',
        remove_car_done: 'Rezervacija za {plate} je otkazana i odbijena s računa boravka.',
        add_car_price: 'Parkirno mjesto za ostatak boravka: {amount}. Iznos se dodaje na račun boravka.',
        add_car_book: 'Rezerviraj i dodaj na račun',
        add_car_done: 'Parkirno mjesto za {plate} je rezervirano i dodano na račun boravka.',
    },
    arrival: {
        title: 'Dolazak u hotel',
        navigate: 'Navigacija',
        back_to_stay: 'Natrag na boravak',
        entrance_title: 'Glavni ulaz',
        entrance_text: 'Kratko zaustavljanje za prtljagu i pristup bez stepenica.',
        parking_title: 'Vanjsko parkiralište',
        parking_text: 'Ulaz sa svojom registarskom oznakom.',
        garage_title: 'Ulaz u garažu',
        garage_text: 'Rampa se otvara automatski kad kamera prepozna registarsku oznaku vozila.',
    },
    services: {
        room_service_link: 'Posluga u sobi',
        title: 'Usluge i doživljaji',
        subtitle: 'Uslugu možete dodati izravno na račun boravka.',
        loading: 'Učitavam ponudu …',
        booked_title: 'VEĆ REZERVIRANO',
        edit: 'Uredi',
        edit_close: 'Zatvori uređivanje',
        edit_save: 'Potvrdi promjenu',
        edit_hint: 'Odaberi nove dane; neprekinuto razdoblje bez rupa.',
        edit_gap: 'Odaberi uzastopne dane — za dva odvojena razdoblja napravi dvije rezervacije.',
        edited: 'Rezervacija je premještena.',
        edit_failed: 'Promjenu nije bilo moguće izvesti — dani su možda već zauzeti. Provjeri popis.',
        desk_only_now: 'Promjena ili otkazivanje samo još putem recepcije.',
        withdraw: 'Otkaži',
        withdrawn: 'Rezervacija je otkazana. Ako je već naplaćena, iznos je storniran.',
        withdraw_failed: 'Otkazivanje nije bilo moguće izvesti — obratite se recepciji.',
        policy_until_start: 'Besplatno otkazivanje putem portala do početka.',
        policy_hours: 'Besplatno otkazivanje putem portala do {hours} h prije početka.',
        policy_desk_only: 'Otkazivanje samo putem recepcije.',
        quantity: 'Koliko',
        per_days: '/ {days} dana',
        days_count: '{days} dana',
        full_days: 'Zauzeto: {days}',
        plate_nth: 'Registarska oznaka {number}. vozila',
        per_day: '/ dan',
        stay_total: '{amount} za {nights} dana',
        book: 'Rezerviraj za boravak',
        full: 'Za vaš boravak više nema slobodnih mjesta.',
        none: 'Hotel trenutno ne nudi usluge koje bi se mogle rezervirati putem portala. Za termine (masaža, večera) obratite se recepciji.',
        confirm_text: 'Rezervacija za cijeli boravak, {from}–{to}. Iznos {amount} dodaje se na vaš hotelski račun.',
        confirm: 'Potvrdi rezervaciju',
        cancel: 'Odustani',
        needs_plate: 'Upišite registarsku oznaku vozila.',
        booked: 'Rezervirano. Usluga je na vašem računu boravka.',
        book_failed: 'Rezervacija nije uspjela — pokušajte ponovno ili se obratite recepciji.',
        status_booked: 'rezervirano',
        status_in_progress: 'u tijeku',
        status_completed: 'obavljeno',
        status_cancelled: 'otkazano',
        status_no_show: 'neiskorišteno',
    },
    room_service: {
        categories: 'Jelovnik',
        my_orders: 'Vaše narudžbe',
        basket_open: 'Košarica',
        basket_title: 'Vaša narudžba',
        when: 'Vrijeme dostave',
        when_asap: 'Što prije',
        when_today: 'Danas u {time}',
        when_tomorrow: 'Sutra u {time}',
        closed_now_later: 'Kuhinja sada ne poslužuje — narudžbu možete predati za kasnije.',
        ordered_at: 'naručeno {when}',
        deliver_for: 'dostava {when}',
        ordered_for: 'Narudžba je primljena za {time} — {amount} na računu sobe.',
        title: 'Posluga u sobi',
        subtitle: 'Naručite iz hotelske kuhinje — iznos se zapisuje na račun sobe.',
        loading: 'Učitavam jelovnik …',
        load_failed: 'Jelovnik nije bilo moguće učitati. Provjerite vezu i pokušajte ponovno.',
        retry: 'Pokušaj ponovno',
        to_room: 'DOSTAVA U SOBU {room}',
        hours: 'Kuhinja danas: {hours}',
        shut_today: 'danas zatvoreno',
        closed_now: 'Kuhinja trenutno ne prima narudžbe. Pokušajte u vrijeme kada je otvorena.',
        less: 'Ukloni jedan',
        more: 'Dodaj jedan',
        empty_menu: 'Hotel još nije ništa dodao na jelovnik.',
        basket: 'VAŠA NARUDŽBA',
        basket_empty: 'Gumbom + dodajete jelo ili piće.',
        total: 'Ukupno',
        note: 'Poruka kuhinji',
        note_placeholder: 'npr. bez luka, dva pribora',
        terms: 'Potvrdom kuhinja prima narudžbu, a iznos se zapisuje na račun sobe i plaća pri odjavi.',
        order: 'Naruči · {amount}',
        sending: 'Šaljem …',
        clear: 'Isprazni',
        orders: 'VAŠE NARUDŽBE',
        ordered: 'Narudžba je primljena — {amount} na računu sobe.',
        retry_hint: 'Odgovor nije stigao. Ponovno pritisnite Naruči — narudžba se neće udvostručiti.',
        failed: 'Kuhinja nije prihvatila narudžbu. Provjerite je i pokušajte ponovno ili nazovite recepciju.',
        not_offered: 'Hotel ne nudi poslugu u sobi putem portala. Za narudžbu nazovite recepciju.',
        not_in_house: 'Posluga u sobi dostupna je nakon prijave u hotel.',
        menu_unreadable: 'Jelovnik trenutno nije moguće pročitati. Pokušajte za nekoliko minuta ili nazovite recepciju.',
    },
    stay_services: {
        per_appointment: '/ termin',
        opens_at_checkin: 'Termine u hotelu (masaža, sauna …) i ponudu partnera u blizini možete rezervirati nakon prijave u hotel.',
        room: 'Za koju sobu',
        appointments: 'TERMINI U HOTELU',
        loading_times: 'Provjeravam slobodne termine …',
        times_failed: 'Slobodne termine nije bilo moguće pročitati. Pokušajte ponovno.',
        departed: 'Vaš boravak je završio — nove termine više nije moguće rezervirati.',
        no_times: 'Do vašeg odlaska nema slobodnih termina.',
        departure_day: 'Na dan odlaska nude se samo termini koji završavaju do {time}.',
        book: 'Rezerviraj · {amount}',
        on_bill: 'na račun sobe',
        booked: 'Termin je rezerviran — {amount} na računu sobe.',
        book_failed: 'Termin nije bilo moguće rezervirati — možda je upravo zauzet. Odaberite ponovno.',
        nearby: 'USLUGE U BLIZINI',
        minutes: '{minutes} min',
        partner_down: 'Partner se trenutno ne javlja. Pokušajte za nekoliko minuta ili pitajte na recepciji.',
        no_times_day: 'Partner taj dan nema slobodnih termina.',
        partner_terms: 'Termin rezerviramo kod partnera {partner}. Plaća se prema dogovoru s hotelom — na račun sobe ili kod partnera.',
        nearby_done: 'Rezervirano — očekuju vas.',
        taken: 'Taj je termin kod partnera upravo zauzet. Odaberite drugi.',
        nearby_booked: 'VAŠI TERMINI KOD PARTNERA',
        cancel: 'Otkaži',
        cancel_confirm: 'Potvrdi otkazivanje',
        cancel_changed: 'Trošak otkazivanja se u međuvremenu promijenio.',
        cancel_unknown: 'Za otkazivanje mogu vrijediti uvjeti partnera {partner} — za trošak pitajte na recepciji ili potvrdite otkazivanje.',
        cancel_late: 'Kasno otkazivanje: partner naplaćuje {amount} na vašu sobu.',
        cancel_late_free: 'Rok za besplatno otkazivanje je istekao, ali partner za ovu uslugu ništa ne naplaćuje.',
        cancel_free: 'Otkazivanje je besplatno do {deadline}.',
        cancel_gone: 'Ovaj termin više nije moguće otkazati ovdje. Pitajte na recepciji.',
        cancelled: 'Termin je otkazan.',
        cancelled_fee: 'Termin je otkazan. Partner će naplatiti {amount} na račun sobe.',
        cancel_failed: 'Otkazivanje nije uspjelo. Pokušajte ponovno ili pitajte na recepciji.',
    },
    order_pin: {
        title: 'PIN za narudžbe',
        hint: 'Hotel prije narudžbe ili rezervacije traži vaš PIN. Dobili ste ga pri prijavi na recepciji ili e-poštom.',
        label: 'PIN',
        confirm: 'Potvrdi',
        wrong: 'PIN nije ispravan. Pokušajte ponovno.',
        locked: 'Previše pogrešnih pokušaja. Pokušajte za nekoliko minuta ili pitajte na recepciji.',
    },
    payment_done: {
        paid_title: 'Plaćanje uspješno',
        paid_text: 'Hvala! Plaćanje je izvršeno — recepcija će ga za nekoliko sekundi vidjeti proknjiženo.',
        cancelled_title: 'Plaćanje nije izvršeno',
        cancelled_text: 'Ništa nije naplaćeno. Za novi pokušaj zamolite recepciju.',
    },
    payments: {
        details_open: 'Pogledaj narudžbu',
        details_total: 'Ukupno',
        details_tax: 'od toga PDV {rate} %: {amount}',
        title: 'Plaćanja i računi',
        reservation: 'Rezervacija {number}',
        open_badge: 'Otvoreno',
        folio_title: 'Račun boravka',
        due: 'Za platiti',
        pay_starting: 'Otvaram plaćanje …',
        pay_failed: 'Plaćanje nije bilo moguće započeti — pokušajte ponovno ili se obratite recepciji.',
        paid_message: 'Plaćanje je uspjelo. Hvala!',
        method_cash: 'gotovina',
        method_card: 'kartica',
        method_transfer: 'bankovni prijenos',
        method_voucher: 'vrijednosni bon',
        method_prepayment: 'predujam',
        method_ota_virtual_card: 'virtualna kartica',
        processing_title: 'Plaćanje se obrađuje',
        processing_text: 'Čekamo potvrdu pružatelja plaćanja. To obično traje nekoliko sekundi — stranica će sama javiti kad plaćanje bude proknjiženo.',
        processing_timeout: 'Potvrde još nema. Ako je plaćanje izvršeno, ubrzo će se pojaviti među stavkama — u suprotnom se obratite recepciji.',
        overpaid_message: 'Plaćeni iznos veći je od otvorenog — razliku će recepcija uskladiti kao dobroimutak.',
        cancelled_message: 'Plaćanje je otkazano.',
        settled_badge: 'Podmireno',
        stripe_note: 'Karticu upisujete na sigurnoj Stripeovoj stranici; hotel podatke o kartici ne vidi i ne pohranjuje. Testno okruženje.',
        pay_now: 'Plati sada',
        proforma: 'Preuzmi predračun',
        proforma_failed: 'Predračun nije bilo moguće pripremiti — pokušajte ponovno.',
        invoices: 'Računi',
        invoices_text: 'Konačni fiskalizirani račun bit će dostupan nakon završetka boravka.',
        documents: 'Dokumenti',
        no_invoice_yet: 'Konačni račun još nije izdan.',
        secure_title: 'Sigurno plaćanje',
        secure_text: 'Podatke o kartici hotel i Imprion ne pohranjuju.',
        pay_title: 'Plaćanje {amount}',
        simulated: 'Simulirano plaćanje — kartica neće biti terećena.',
        simulated_done: 'Ovo je bila simulacija — online plaćanje stiže s jednom od sljedećih verzija.',
        cardholder: 'Vlasnik kartice',
        card_number: 'Broj kartice',
        expiry_cvc: 'Vrijedi / CVC',
        pay_secure: 'Sigurno plati',
    },
    studio: {
        button: 'Prilagodi portal',
        title: 'Prilagodba hotelskog portala',
        hint: 'Pretpregled za postavljanje pojedinog objekta. Imprion Guest ostaje označen kao pružatelj portala.',
        primary: 'Glavna boja',
        accent: 'Istaknuta boja',
        compact: 'uglatiji elementi',
        preview_only: 'Samo pretpregled — izgled hotela sprema recepcija.',
    },
    license: {
        eyebrow: 'Online prijava',
        title: 'Ova usluga nije uključena',
        lead: 'Ovaj hotel nema uključenu online prijavu, pa se ovaj portal ne može otvoriti. Vaša rezervacija time nije ni na koji način promijenjena.',
        another_link: 'Ako ste u međuvremenu dobili drugu poveznicu, jednostavno je otvorite — ova stranica će se ponovno učitati.',
        contact: 'Za sve o svom boravku obratite se recepciji hotela — rado će vam pomoći.',
    },
    memory: {
        eyebrow: 'Uspomena na boravak',
        thanks: 'Hvala na posjetu',
        lead: 'Bilo nam je zadovoljstvo. Ovdje ostaje kratka uspomena na vaš boravak.',
        stayed: 'Boravak',
        room: 'Soba',
        used: 'Što ste koristili',
        nights: 'Noćenja',
        nights_one: '{n} noć',
        nights_two: '{n} noći',
        nights_few: '{n} noći',
        nights_many: '{n} noći',
        guests: 'Gosti',
        guests_one: '{n} osoba',
        guests_two: '{n} osobe',
        guests_few: '{n} osobe',
        guests_many: '{n} osoba',
        book_again: 'Rezervirajte ponovno',
        invoice: 'Molim račun na e-poštu',
        invoice_sending: 'Šaljem …',
        invoice_sent: 'Račun je poslan na e-adresu koju ste naveli.',
        invoice_failed: 'Račun trenutačno nije bilo moguće poslati. Pokušajte kasnije ili pišite hotelu.',
        privacy: 'Ova stranica ostaje otvorena i ne sadrži osobne podatke.',
    },
    invalid: {
        demo_opening: 'Otvaram boravak …',
        hotel_fallback: 'Vaš hotel',
        reception: 'Recepcija',
        eyebrow: 'Trebate novu poveznicu?',
        title: 'Bez brige — brzo ćemo srediti novu',
        text: 'Ova poveznica zbog sigurnosti više ne vrijedi. Vaša rezervacija time nije otkazana i nijedan podatak nije izgubljen.',
        help_title: 'Kako nastaviti',
        step_contact_title: 'Obratite se recepciji',
        step_contact_text: 'Nazovite hotel ili mu pošaljite kratku poruku.',
        step_identify_title: 'Recite o kojem se boravku radi',
        step_identify_text: 'Dovoljni su ime gosta i predviđeni datum dolaska.',
        step_open_title: 'Otvorite novu poveznicu',
        step_open_text: 'Hotel će vam je poslati e-poštom ili porukom.',
        retry: 'Pokušaj ponovno',
        security: 'Poveznice vremenski ograničavamo kako bismo zaštitili podatke o vašem boravku.',
    },
    /*
     * Kuća — sadržaj sobnih televizora na telefonu (docs/DISPLAY.md §9).
     *
     * Vlastiti imenski prostor jer je ovo zgrada, a ne boravak: isti tekst vidi svaki
     * gost u kući, bez obzira na svoju rezervaciju. Izrazi su namjerno isti kao na
     * zaslonima (`house.*`, `local.kind_*` u pms-display), da kuća na zidu i na telefonu
     * ne govori dva jezika.
     */
    house: {
        sign_up: 'Prijavi nas',
        signed_up: 'Prijavljeni',
        signup_count: '{count} prijavljenih',
        guest_deal: 'Za goste hotela: {deal}',
        voucher_title: 'Vaš kupon za popuste',
        voucher_open: 'Otvori kupon',
        voucher_note: 'Pokažite QR ili otvorite poveznicu kod partnera — stranica uživo potvrđuje da ste gost hotela.',
        locked_eye: 'Otključava se pri prijavi',
        locked_text: 'Sadržaji hotela — Wi-Fi, pismo dobrodošlice, program i okolica — otključavaju se na vašem telefonu pri prijavi. Vidimo se na recepciji!',
        title: 'Hotel',
        loading: 'Učitavam …',
        failed: 'Sadržaj hotela trenutno nije moguće prikazati. Pokušajte za nekoliko trenutaka.',
        section_house: 'DOBRODOŠLI',
        section_letter: 'PISMO DOBRODOŠLICE',
        section_today: 'DANAS U HOTELU',
        section_weather: 'VRIJEME',
        section_services: 'USLUGE I CJENIK',
        section_events: 'DOGAĐAJI U OKOLICI',
        section_places: 'ZNAMENITOSTI U OKOLICI',
        wifi: 'Bežična mreža',
        network: 'Mreža',
        password: 'Lozinka',
        wifi_open: 'Mreža je otvorena, lozinka nije potrebna.',
        hours: 'Radno vrijeme',
        phone_keys: 'Tipke telefona',
        room_phone: 'S telefona u sobi.',
        emergency: 'Hitni poziv',
        per_day: '/ dan',
        per_item: '/ jednokratno',
        to_services: 'Rezervirajte uslugu',
        open_in_maps: 'Otvori u Google Kartama',
        kind_sight: 'Znamenitost',
        kind_restaurant: 'Gdje jesti',
        kind_activity: 'Aktivnost',
        kind_shop: 'Kupnja',
        kind_other: 'Ostalo u okolici',
    },
    /* Prognoza je Open-Meteo; `weather` je riječ za nebo koju prevodi zaslon. */
    weather: {
        today: 'danas',
        rain_chance: '{percent} %',
        clear: 'vedro',
        partly_cloudy: 'djelomično oblačno',
        overcast: 'oblačno',
        fog: 'magla',
        drizzle: 'rosulja',
        rain: 'kiša',
        rain_showers: 'pljuskovi',
        snow: 'snijeg',
        snow_showers: 'snježni pljuskovi',
        thunderstorm: 'grmljavina',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     */
    milo: {
        title: 'Milo',
        greeting: 'Pozdrav, ja sam Milo.',
        intro: 'Pitajte me o hotelu i svom boravku — odgovaram na vašem jeziku.',
        placeholder: 'Napišite pitanje …',
        send: 'Pošalji',
        thinking: 'Milo razmišlja …',
        still_working: 'Još tražim — može potrajati minutu.',
        disclaimer: 'Milo je pomoćnik hotela. Ne prima uplate i ne izdaje račune; za sve ostalo tu je recepcija.',
        open: 'Otvori Mila',
        close: 'Zatvori',
        chip_wifi: 'Wi-Fi',
        chip_wifi_text: 'Koja je lozinka za Wi-Fi?',
        chip_breakfast: 'Doručak',
        chip_breakfast_text: 'Do kada se poslužuje doručak?',
        chip_late_checkout: 'Kasniji odlazak',
        chip_late_checkout_text: 'Mogu li ostati u sobi malo dulje?',
        chip_today: 'Što se događa danas',
        chip_today_text: 'Što se danas događa u okolici?',
        confirm: 'Potvrdi',
        decline: 'Ne, ne sada',
        executed: 'Poslano',
        declined: 'Nije poslano.',
        failed: 'Nije uspjelo. Pokušajte ponovno ili nazovite recepciju.',
        expired: 'Ovaj prijedlog je istekao. Pitajte ponovno.',
        already_decided: 'O ovom prijedlogu već je odlučeno.',
        card_closed: 'Ovaj prijedlog više nije moguće potvrditi.',
        budget_spent: 'Za danas je pitanja dosta. Sutra ponovno, ili nazovite recepciju.',
        throttled: 'Trenutak — pokušajte ponovno za nekoliko sekundi.',
        too_long: 'Milu je za ovo pitanje trebalo predugo. Pitajte nešto određenije, ili nazovite recepciju.',
        interrupted: 'Milo je prekinut dok je odgovarao. Pitajte, molimo, još jednom.',
        unavailable: 'Milo trenutačno nije dostupan. Recepcija vam stoji na raspolaganju.',
        result: {
            late_checkout_requested:    'Vaša zamolba za kasniji odlazak je na recepciji.',
            guest_service_booked_one:   'Rezervirano za {count} dan.',
            guest_service_booked_two:   'Rezervirano za {count} dana.',
            guest_service_booked_few:   'Rezervirano za {count} dana.',
            guest_service_booked_other: 'Rezervirano za {count} dana.',
            room_request_raised:        'Vaša zamolba je kod domaćinstva.',
            reception_message_sent:     'Vaša poruka je na recepciji.',
            room_service_ordered_one:   'Kuhinja ima vašu narudžbu: {count} stavka, {detail}.',
            room_service_ordered_two:   'Kuhinja ima vašu narudžbu: {count} stavke, {detail}.',
            room_service_ordered_few:   'Kuhinja ima vašu narudžbu: {count} stavke, {detail}.',
            room_service_ordered_other: 'Kuhinja ima vašu narudžbu: {count} stavki, {detail}.',
            lost_item_reported:         'Vaša prijava upisana je pod {detail}; recepcija će vas obavijestiti.',
            transfer_requested:         'Vaša zamolba za prijevoz ({detail}) je na recepciji.',
        },
    },
}
